import { UpcomingEvent } from "../types";

export const upcomingEventsData: UpcomingEvent[] = [
  {
    id: "upcoming-tasc-night-market-2026",
    title: "TASC Night Market",
    date: "2026-10-10T18:00:00-05:00",
    location: "Bardeen Quad",
    description:
      "Night market event featuring a food stall serving Mie Ayam. Time: 6:00 PM – 9:00 PM.",
    cover_image: "/events/upcoming/pasmal2024.png",
    ticket_price: "Free Entry",
  },
  {
    id: "upcoming-ongoing-social-outings-2026",
    title: "Ongoing Social Outings",
    date: "2026-10-18T14:00:00-05:00",
    location: "Campus & Champaign-Urbana",
    description:
      "Future community activities currently in the planning stages include weekend badminton and volleyball sessions, ice skating, soccer, bouldering in collaboration with MASA at Boneyard Boulders, and a group trip to Matthiessen State Park.",
    cover_image: "/events/upcoming/irlMeetGreet.png",
    ticket_price: "Community Activity",
  },
];
